<template>
    <ContentOrLoading>
        <div v-if="!carrito && !pedidos && !n_pedido" class="container-vacio">
            <b-col class="text-center">
                <h3>Tu cesta está vacía</h3>
                <p>Explora multitud de eventos y experiencias en nuestra página</p>
            </b-col>
        </div>

        <div v-else-if="!loading" class="container">
            <b-row>
                <TimerEntradasComponent pt="pt-2" v-if="carrito && !pedidos && !n_pedido" :secondsLeft="carrito?.seconds_left"/>
            </b-row>
            <b-row>
                <b-col md="8" sm="12">
                    <SteepsComponent :active="active_tab" />
                </b-col>
            </b-row>
            <b-row>
                <b-col md="8" sm="12">
                    <ListadoEntradasComponent
                        v-if="active_tab == 1"
                        :entradas="carritoItems"
                        @eliminarProducto="eliminarProducto"
                    />
                    <DatosPedidoComponent
                        v-if="active_tab == 2"
                        ref="datosPedido"
                        :entradas="carritoItems"
                        :datos_compradores="datos_compra"
                        @continuar="guardarDatos"
                    />
                    <RealizarCompra
                        v-if="active_tab == 3"
                        ref="realizarCompra"
                        :entradas="carritoItems"
                        :datos_compra="datos_compra"
                    />
                    <CompraConfirmada
                        v-if="active_tab == 4"
                        ref="compraConfirmada"
                        :n_pedido="n_pedido"
                        :pedidos="pedidos"
                        :datos_compra="datos_compra"
                    />
                </b-col>
                <b-col md="4" sm="12">
                    <ResumenCarritoComponent
                        v-if="active_tab !== 4"
                        :buttonTitle="buttonTitle"
                        :active_tab="active_tab"
                        :datosCompra="datos_compra"
                        @continuar="continuar"
                        @volver="volver"
                    />
                </b-col>
            </b-row>
        </div>    
    </ContentOrLoading>
</template>

<script>
import TimerEntradasComponent from '@/components/common/carrito/TimerEntradasComponent';
import SteepsComponent from '@/components/common/carrito/SteepsComponent';
import ListadoEntradasComponent from '@/components/common/carrito/ListadoEntradasComponent.vue';
import ResumenCarritoComponent from '@/components/common/carrito/ResumenCarritoComponent.vue';
import DatosPedidoComponent from '@/components/backend/carrito/DatosPedidoComponent.vue';
import RealizarCompra from '@/components/backend/carrito/RealizarCompra.vue';
import CompraConfirmada from '@/components/backend/carrito/CompraConfirmada.vue';

export default {
    data() {
        return {
            active_tab: 1,
            loading: false,
            datos_compra: {},
            datos_entradas: {},
            pedidos: null,
            n_pedido: null
        }
    },
    methods: {
        eliminarProducto(item_id) {
            this.loading = true;

            const cart_id = this.carrito?.id;

            const params = {
                cart_id: cart_id,
                item_id: item_id
            };

            this.$store.dispatch(this.config.getVuexAlias('taquilla.carrito.delete-items'), params).then(res => {
                this.$toast.success('Entrada borrada correctamente');
                this.actualizarCarrito();
            }).catch(error => {
                console.log(error)
            }).finally(() => {
                this.loading = false;
            });
        },
        continuar() {
            switch (this.active_tab) {
            case 1:
                this.active_tab++
                break;

            case 2:
                this.$refs.datosPedido.terminar();
                break;

            case 3:
                this.guardarDatos(this.datos_compra, null);
                break;
            
            default:
                this.active_tab++
                break;
            }            
        },
        guardarDatos(datos_compra, datos_entradas) {
            this.loading = true;
            this.datos_compra = datos_compra;
            this.datos_entradas = datos_entradas || this.datos_entradas || {};

            const params = {
                filters: {},
                cart_id: this.carrito?.id,
                datos_compradores: datos_compra,
                items: this.datos_entradas
            };

            this.$store.dispatch(this.config.getVuexAlias('taquilla.carrito.guardar-datos'), params).then(res => {
                if (this.active_tab == 2) {
                    this.active_tab++;
                } else if (this.active_tab == 3) {
                    this.procesar();
                }
            }).catch(err => {
                console.error('Error actualizando carrito taquilla:', err);
            }).finally(() => {
                this.loading = false;
            });
        },
        procesar() {
            this.loading = true;
            
            const params = {
                filters: {},
                cart_id: this.carrito?.id
            };
            
            this.$store.dispatch(this.config.getVuexAlias('taquilla.carrito.procesar'), params).then(res => {
                this.$store.dispatch('TAQUILLA_CARRITO_ACTIVO')
                this.n_pedido = res.data.n_pedido;
                this.pedidos = res.data.pedidos;
                this.active_tab++;
            }).catch(err => {
                console.error('Error procesando carrito taquilla:', err);
            }).finally(() => {
                this.loading = false;
            });
        },
        actualizarCarrito() {
            this.$store.dispatch('TAQUILLA_CARRITO_ACTIVO').then(res => {
                if (res.data.data.items_count === 0) {
                    return this.$router.push({ path: '/admin/eventos' });
                }
            });
        },
        volver() {
            return this.active_tab--;
        }
    },
    computed: {
        buttonTitle() {
            let title = 'Continuar';

            switch (this.active_tab) {
            case 1:
                title = 'Continuar compra';
                break;
            case 2:
                title = 'Continuar compra';
                break
            case 3:
                title = 'Finalizar compra';
                break
            case 4:
                title = '¡Compra finalizada!';
                break
            }

            return title;
        },
        carrito() {
            return this.$store.getters.getCarritoActivo;
        },
        carritoItems() {
            return this.$store.getters.getCarritoItems;
        }
    },
    components: {
        TimerEntradasComponent, SteepsComponent, ListadoEntradasComponent, ResumenCarritoComponent, DatosPedidoComponent, RealizarCompra, CompraConfirmada
    }
}
</script>

<style scoped>
.container {
    line-height: 1.3;
    font-family: "Oswald", s;
    margin-top: 20px;
}

.container-vacio {
    line-height: 1.3;
    font-family: "Oswald", sans-serif;
    text-align: center;
    padding: 12rem 2rem; 
}

@media (min-width: 768px) {
    .container-vacio {
        padding: 12rem 5rem;
    }
}
</style>